import { Injectable } from '@angular/core';
// import {Network, NetworkOriginal} from '@awesome-cordova-plugins/network';
import { Platform } from '@ionic/angular';
import { map } from 'rxjs/operators';

/*
 Generated class for the ConnectionService provider.

 See https://angular.io/docs/ts/latest/guide/dependency-injection.html
 for more info on providers and Angular 2 DI.
 */
@Injectable()
export class ConnectionService {
    private connected: boolean;
    private connectionType;
    private networktype: string;
    constructor(private platform: Platform) {
        //   const net= new NetworkOriginal();
        //   this.networktype=net.type;
        //         net.onConnect().subscribe(() => {
        //             this.onConnect();
        //         });
        //         net.onDisconnect().subscribe(() => {
        //             this.onDisconnect();
        //         });
    }

    private onConnect() {
        this.connected = true;
        setTimeout(() => {
            this.connectionType = this.networktype;
        });
    }

    private onDisconnect() {
        this.connected = false;
        this.connectionType = null;
    }

    /**
     * Checks whether connected to network or not
     * @returns {boolean} Returns true if connected to network
     */
    public isConnected(): boolean {
        if (this.platform.is('capacitor'))
            return this.networktype !== 'none';
        else return true;
    }

    /**
     * Checks whether you are connected to WiFi network
     * @returns {boolean} True if connected to WiFi network
     */
    public isWifi(): boolean {
        if (this.platform.is('capacitor'))
            return this.networktype === "wifi";
        else return false;
    }

    /**
     * Checks whether your are connected to 4G network
     * @returns {boolean}
     */
    public is4G(): boolean {
        if (this.platform.is('capacitor'))
            return this.networktype === "4g";
        else return false;
    }

    /**
     * Checks whether connected to 3G network
     * @returns {boolean}
     */
    public is3G(): boolean {
        if (this.platform.is('capacitor'))
            return this.networktype === "3g";
        else return false;
    }

    /**
     * Checks whether connected to 2G network
     * @returns {boolean}
     */
    public is2G(): boolean {
        if (this.platform.is('capacitor'))
            return this.networktype === "2g";
        else return false;
    }
}



